import { graphql } from 'msw';

import { constants } from '@trqk/utils';

import { hasValidToken } from '../utils';

export const listTrqkStatementViewsActive = graphql.query<
    ListTrqkStatementViewsActiveQuery,
    ListTrqkStatementViewsActiveQueryVariables
>('listTrqkStatementViewsActive', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                listTrqkStatementViews: {
                    items: [
                        {
                            statement_id: '1636737958AS0311628420202P',
                            start_date: '2020-04-01',
                            status_name:
                                'COMPLETE' as TrqkStatementViewStatusName,
                            end_date: '2020-06-30',
                            pro: 'ASCAP',
                            region: 'standard' as ProRegionType,
                            user_id: constants.TEST_USERS.PUBLISHER.ID,
                            unit: 'quarter',
                            earnings: 1598.63,
                            name: 'Test Publisher',
                            role_type: 'publisher' as ProAffiliateType,
                        },
                        {
                            statement_id: '1636737957AS0311628420194P',
                            start_date: '2019-10-01',
                            status_name:
                                'COMPLETE' as TrqkStatementViewStatusName,
                            end_date: '2019-12-31',
                            pro: 'ASCAP',
                            region: 'standard' as ProRegionType,
                            user_id: constants.TEST_USERS.PUBLISHER.ID,
                            unit: 'quarter',
                            earnings: 2124.05,
                            name: 'Test Publisher',
                            role_type: 'publisher' as ProAffiliateType,
                        },
                    ],
                    nextToken: null,
                },
            }),
        );
    }

    return res();
});
